import {
  _loginSuccess,
  _studentDataResponse,
  candidateAssignedPrograms,
  _studentDashboardResponse,
  _switchWhiteLabelProp,
  _uploadedImageForShare,
  _base64ProfileImage,
  _uploadToStorage,
  _createNewFeed,
  _emLeadsData,
  // _getParentQuestions,
  // _getQuestions,
  // _getSubmitReponse
} from "./types";

import { getBaseUrl } from "./utility";

import axios from "axios";

const instance = axios.create({
  baseURL: getBaseUrl() + "/",
});

// Configure the provider with the necessary options.
// const options = {
// 	token: 'abc',
// 	headers: {
// 		'Content-Type': 'application/json'
// 	}
// };
// const options = {};
// instance.interceptors.request.use(tokenProvider(options));

export const doLogin =
  (userEmail, userPass, userType, storeid = 2) =>
  async (dispatch) => {
    var bodyFormData = new FormData();

    bodyFormData.set("email", userEmail);
    bodyFormData.set("password", userPass);
    bodyFormData.set("client_id", storeid);
    bodyFormData.set("user_type", userType);
    // bodyFormData.set('courseid', 0);
    // bodyFormData.set('purchase', 0);
    // bodyFormData.set('storeid', storeid);

    // instance.post('/api/v1/signin', bodyFormData, {
    instance
      .post("/api/v1/user/feed/login", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          // if success only
          dispatch({
            type: _loginSuccess,
            payload: res.data,
          });
        } else {
          if (res.data.status == "error") {
            dispatch({
              type: _loginSuccess,
              payload: res.data,
            });
          } else {
            dispatch({
              type: _loginSuccess,
              payload: res.data,
            });
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        dispatch({
          type: _loginSuccess,
          payload: "error",
        });
      });
  };

export const getAllAccounts = (userEmail, storeid) => async (dispatch) => {
  var bodyFormData = new FormData();

  bodyFormData.set("email_number", userEmail);
  bodyFormData.set("client_id", storeid);

  return instance
    .post("/api/v1/getallaccountsofuser", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        return res;
        // if success only
        // dispatch({
        //   type: _loginSuccess,
        //   payload: res.data,
        // });
      } else {
        if (res.data.status == "error") {
          return res;
          // dispatch({
          //   type: _loginSuccess,
          //   payload: res.data,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _loginSuccess,
          //   payload: res.data,
          // });
        }
      }
    })
    .catch((error) => {
      debugger;
      // console.log(error);
      // dispatch({
      //   type: _loginSuccess,
      //   payload: "error",
      // });
    });
};

export const loginUser = (userName, password) => async (dispatch) => {
  var bodyFormData = new FormData();

  bodyFormData.set("email", userName);
  bodyFormData.set("password", password);
  bodyFormData.set("courseid", 0);
  bodyFormData.set("purchase", 0);
  bodyFormData.set("isPassRequired", 1);
  bodyFormData.set("storeid", 2);

  return instance
    .post("/api/v1/signin", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        return res;
        // if success only
        // dispatch({
        //   type: _loginSuccess,
        //   payload: res.data,
        // });
      } else {
        if (res.data.status == "error") {
          return res;
          // dispatch({
          //   type: _loginSuccess,
          //   payload: res.data,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _loginSuccess,
          //   payload: res.data,
          // });
        }
      }
    })
    .catch((error) => {
      debugger;
      // console.log(error);
      // dispatch({
      //   type: _loginSuccess,
      //   payload: "error",
      // });
    });
};

export const loginEmTeacher = (userName, password) => async (dispatch) => {
  var bodyFormData = new FormData();

  bodyFormData.set("email", userName);
  bodyFormData.set("password", password);
  bodyFormData.set("client_id", 2);

  return instance
    .post("/api/v1/user/feed/login", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        return res;
        // if success only
        // dispatch({
        //   type: _loginSuccess,
        //   payload: res.data,
        // });
      } else {
        if (res.data.status == "error") {
          return res;
          // dispatch({
          //   type: _loginSuccess,
          //   payload: res.data,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _loginSuccess,
          //   payload: res.data,
          // });
        }
      }
    })
    .catch((error) => {
      debugger;
      // console.log(error);
      // dispatch({
      //   type: _loginSuccess,
      //   payload: "error",
      // });
    });
};

export const getStudentData = (studentId, offset) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("student_id", studentId);
  bodyFormData.set("offset", offset);

  instance
    .post("/api/v1/lm/feeds", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          // if success only
          dispatch({
            type: _studentDataResponse,
            payload: res.data.result,
          });
        } else {
          dispatch({
            type: _studentDataResponse,
            payload: "error_" + Math.random(),
          });
        }
      } else {
        dispatch({
          type: _studentDataResponse,
          payload: "error",
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getStudentNextData = (studentId, offset) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("student_id", studentId);
  bodyFormData.set("offset", offset);

  instance
    .post("/api/v1/lm/feeds", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          // if success only
          dispatch({
            type: _studentDataResponse,
            payload: res.data.result,
          });
        } else {
          dispatch({
            type: _studentDataResponse,
            payload: "error_" + Math.random(),
          });
        }
      } else {
        dispatch({
          type: _studentDataResponse,
          payload: "error",
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getDashboardData = (studentId) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("student_id", studentId);

  instance
    .post("/api/v1/skillupz/feeds", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          // if success only
          dispatch({
            type: _studentDashboardResponse,
            payload: res.data.result,
          });
        } else {
          dispatch({
            type: _studentDashboardResponse,
            payload: "error_" + Math.random(),
          });
        }
      } else {
        dispatch({
          type: _studentDashboardResponse,
          payload: "error",
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getScoresData = (user_id) => {
  return instance
    .get(`/api/v1/user/feed/testscore?student_id=${user_id}`, {
      headers: {
        "Content-Type": "application/JSON",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only

        return res.data;
      } else {
        if (res.data.status == "error") {
          return res.data;
        } else {
        }
      }
    })
    .catch((error) => {});
};

export const getDashboardNextData =
  (studentId, assessId, assessName, progId) => async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("student_id", studentId);
    bodyFormData.set("assess_id", assessId);
    bodyFormData.set("chapter_name", assessName);
    bodyFormData.set("prog_id", progId);

    instance
      .post("/api/v1/skillupz/feeds", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        // console.log(res);
        if (res.status == 200) {
          if (typeof res.data.status != "undefined" && res.data.status == "success") {
            // if success only
            dispatch({
              type: _studentDashboardResponse,
              payload: res.data.result,
            });
          } else {
            dispatch({
              type: _studentDashboardResponse,
              payload: "error_" + Math.random(),
            });
          }
        } else {
          dispatch({
            type: _studentDashboardResponse,
            payload: "error",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

//get all programs assigned to specific student
export const getAllAssignedPrograms = (studentId) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("student_id", studentId);

  instance
    .post("/api/assignedprograms", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log('here i get all programs data: ', res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          // if success only
          dispatch({
            type: candidateAssignedPrograms,
            payload: res,
          });
        } else {
          dispatch({
            type: candidateAssignedPrograms,
            payload: res,
          });
        }
      } else {
        console.log("Some thing went wrong! Error code:" + res.status);
      }
    })
    .catch((error) => {
      console.log(error);
      if (typeof error.status === "undefined") console.log("Network error!");
      else console.log("Some thing went wrong!");
    });
};

//upload share image to S3 storage for specific test id
export const uploadSharableImageToS3 =
  (imageData, student_id, prog_id, assess_id, test_id, key) => async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("image", imageData);
    bodyFormData.set("student_id", student_id);
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("assess_id", assess_id);
    bodyFormData.set("test_id", test_id);

    instance
      .post("/api/uploadshareimage", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        // console.log('here is the share image upload res: ', res);
        if (res.status == 200) {
          if (typeof res.data.status != "undefined" && res.data.status == "success") {
            // if success only
            dispatch({
              type: _uploadedImageForShare,
              payload: {
                data: res.data.result,
                key: key,
                random: Math.random(),
              },
            });
          } else {
            dispatch({
              type: _uploadedImageForShare,
              payload: {
                data: res.data.result,
                key: key,
                random: Math.random(),
              },
            });
          }
        } else {
          console.log("Some thing went wrong! Error code:" + res.status);
        }
      })
      .catch((error) => {
        console.log(error);
        if (typeof error.status === "undefined") console.log("Network error!");
        else console.log("Some thing went wrong!");
      });
  };

export const switchToWhiteLabelView = (value) => async (dispatch) => {
  dispatch({
    type: _switchWhiteLabelProp,
    payload: Math.random() + "-" + value,
  });
};

export const convertS3ImageToBase64 = (img_url) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("url", img_url);

  instance
    .post("/api/imageurltobase64", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          // if success only
          dispatch({
            type: _base64ProfileImage,
            payload: res.data.result,
          });
        } else {
          dispatch({
            type: _base64ProfileImage,
            payload: "error_" + Math.random(),
          });
        }
      } else {
        dispatch({
          type: _base64ProfileImage,
          payload: "error",
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

//upload the image upload by user to AWS storage
export const uploadToCloudStorage = (imageData, imgCount) => async (dispatch) => {
  var header = {
    headers: {
      "Content-Type": "multipart/form-data",
      // 'appKey': 'lm-app'
    },
  };
  var bodyFormData = new FormData();
  bodyFormData.set("image", imageData);

  instance
    .post("/api/v1/uploadawsimage", bodyFormData, header)
    .then((res) => {
      console.log("here i am uploadToCloudStorage", res);

      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          // if success only
          dispatch({
            type: _uploadToStorage,
            payload: {
              data: res.data,
              count: imgCount,
              random: Math.random(),
            },
          });
        } else {
          dispatch({
            type: _uploadToStorage,
            payload: {
              data: res.data,
              count: imgCount,
              random: Math.random(),
            },
          });
        }
      } else {
        console.log(res.status);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const createStudentNewFeed = (feedData) => async (dispatch) => {
  var header = {
    headers: {
      "Content-Type": "multipart/form-data",
      // 'appKey': 'lm-app'
    },
  };
  var bodyFormData = new FormData();
  bodyFormData.set("feed_clientid", feedData.feed_clientid);
  bodyFormData.set("feed_teacherid", feedData.feed_teacherid);
  bodyFormData.set("feed_studentid", feedData.feed_studentid);
  bodyFormData.set("feed_prog_id", feedData.feed_prog_id);
  bodyFormData.set("feed_asses_id", feedData.feed_asses_id);
  bodyFormData.set("feed_topic_id", feedData.feed_topic_id);
  bodyFormData.set("feed_iscomplete", feedData.feed_iscomplete);
  bodyFormData.set("feed_data", feedData.feed_data);
  bodyFormData.set("feed_notifyparent", feedData.feed_notifyparent);
  bodyFormData.set("feed_isself", feedData.feed_isself);

  instance
    .post("/api/v1/createfeed", bodyFormData, header)
    .then((res) => {
      console.log("feed uploaded here: ", res.status);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          // if success only
          dispatch({
            type: _createNewFeed,
            payload: {
              data: res.data,
              random: Math.random(),
            },
          });
        } else {
          dispatch({
            type: _createNewFeed,
            payload: {
              data: res.data,
              random: Math.random(),
            },
          });
        }
      } else {
        console.log("Some thing went wrong! Error code:" + res.status);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const notifyReadFeedStatus = (stdID, messageId) => async (dispatch) => {
  console.log(stdID, messageId);
  var header = {
    headers: {
      "Content-Type": "multipart/form-data",
      // 'appKey': 'lm-app'
    },
  };

  instance
    .get("/updatenotificationstat/" + stdID + "/" + messageId, header)
    .then((res) => {
      console.log("feed read successfull here: ", res);
    })
    .catch((error) => {
      console.log(error);
    });
};

//Leads Action Creator

export const leadsData = (data) => async (dispatch) => {
  dispatch({
    type: _emLeadsData,
    payload: data,
  });
};

//End Leads Action
export const getMonthsOfEvaluation = (user_id, clientId, prog_id) => {
  return instance
    .get(
      `/api/v1/evaluation/months?student_id=${user_id}&client_id=${clientId}&prog_id=${prog_id}`,
      {
        headers: {
          "Content-Type": "application/JSON",
        },
      }
    )
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only

        return res;
      } else {
        if (res.data.status == "error") {
          return res;
        } else {
        }
      }
    })
    .catch((error) => {});
};

export const getEvaluationsOnFeed = (user_id, clientId, prog_id, month) => {
  return instance
    .get(
      `/api/v1/evaluations?student_id=${user_id}&client_id=${clientId}&prog_id=${prog_id}&month=${month}`,
      {
        headers: {
          "Content-Type": "application/JSON",
        },
      }
    )
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only

        return res;
      } else {
        if (res.data.status == "error") {
          return res;
        } else {
        }
      }
    })
    .catch((error) => {});
};

export const getFeedbackForDemoStudent = (user_id) => {
  return instance
    .get(`/api/v1/demo/student/feedback?student_id=${user_id}`, {
      headers: {
        "Content-Type": "application/JSON",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only

        return res;
      } else {
        if (res.data.status == "error") {
          return res;
        } else {
        }
      }
    })
    .catch((error) => {});
};

export const getCourseDetailsForfeedback = (course_id) => {
  return instance
    .get(`/api/v1/feeds/course/details?course_id=${course_id}&client_id=2`, {
      headers: {
        "Content-Type": "application/JSON",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only

        return res;
      } else {
        if (res.data.status == "error") {
          return res;
        } else {
        }
      }
    })
    .catch((error) => {});
};

export const getClassAvailability = (courseId) => {
  var bodyFormData = new FormData();
  bodyFormData.set("courseid", courseId);

  return instance
    .post("/api/v1/getclassavailbility", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateTimeTable = (courseId, teacher_id, student_id, prog_id) => {
  var bodyFormData = new FormData();
  bodyFormData.set("course_id", courseId);
  bodyFormData.set("teacher_id", teacher_id);
  bodyFormData.set("student_id", student_id);
  bodyFormData.set("prog_id", prog_id);

  return instance
    .post("/api/v1/update/course/timetable", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

//Checkout Functions

export const ReActivateCourseJazzCash = (
  courseId,
  student_id,
  prog_id,
  amount,
  course_name,
  discount_amount,
  coupon_id
) => {
  var bodyFormData = new FormData();
  bodyFormData.set("courseid", courseId);
  bodyFormData.set("coupon_id", coupon_id);
  bodyFormData.set("userid", student_id);
  bodyFormData.set("program_id", prog_id);
  bodyFormData.set("discount_amount", discount_amount);
  bodyFormData.set("amount", amount);
  bodyFormData.set("course_name", course_name);

  return instance
    .post("/api/v1/reactivatecoursejazzcash", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const fetchJazzCashAddiotionalData = (user_id) => {
  var bodyFormData = new FormData();
  bodyFormData.set("user_id", user_id);

  return instance
    .post("/api/v1/lm/beforecheckout", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const uploadWorksheet = (
  testId,
  userId,
  fileLabel,
  fileSource,
  fileData,
  isOtherSource,
  worksheetId
) => {
  var bodyFormData = new FormData();
  bodyFormData.set("test_id", testId);
  bodyFormData.set("file_label", fileLabel);
  bodyFormData.set("file_source", fileSource);
  bodyFormData.set("user_id", userId);
  bodyFormData.set("file_worksheet", fileData);
  bodyFormData.set("sheet_id", worksheetId);
  bodyFormData.set("is_api", 1);
  bodyFormData.set("isOtherSource", isOtherSource);
  return instance
    .post("/api/v1/worksheet/upload", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
export const addWorksheetLink = (
  testId,
  userId,
  addLink,
  addLinkSource,
  sourceEmail,
  linkLabel
) => {
  var bodyFormData = new FormData();
  bodyFormData.set("test_id", testId);
  bodyFormData.set("add_link", addLink);
  bodyFormData.set("add_link_source", addLinkSource);
  bodyFormData.set("user_id", userId);
  bodyFormData.set("source_email", sourceEmail);
  bodyFormData.set("link_label", linkLabel);
  bodyFormData.set("sheet_id", 0);
  bodyFormData.set("is_api", 1);
  return instance
    .post("/api/v1/worksheet/link", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
export const applyCheckoutCoupon = (courseid, couponcode, dayid) => {
  var bodyFormData = new FormData();

  bodyFormData.set("courseid", courseid);
  bodyFormData.set("couponcode", couponcode);
  bodyFormData.set("dayid", dayid);

  return instance
    .post("/api/v1/validatecoupon", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const paymentCashOnDelivery = (
  userid,
  courseid,
  couponcode,
  dayid,
  payinclass_details,
  order_address,
  pickupmethod,
  location,
  contact_number,
  word_problem,
  logic_reasoning,
  reading_comprehennsion,
  grammer_vocabulary,
  lincoln_method,
  macmillan_education,
  mcgraw_hill,
  scholastic,
  combination_resources
) => {
  var bodyFormData = new FormData();

  bodyFormData.set("userid", userid);
  bodyFormData.set("courseid", courseid);
  bodyFormData.set("couponcode", couponcode);
  bodyFormData.set("dayid", dayid);
  bodyFormData.set("payinclass_details", payinclass_details);
  bodyFormData.set("order_address", order_address);
  bodyFormData.set("pickupmethod", pickupmethod);
  bodyFormData.set("location", location);
  bodyFormData.set("contact_number", contact_number);
  bodyFormData.set("word_problem", word_problem);
  bodyFormData.set("logic_reasoning", logic_reasoning);
  bodyFormData.set("reading_comprehennsion", reading_comprehennsion);
  bodyFormData.set("grammer_vocabulary", grammer_vocabulary);
  bodyFormData.set("lincoln_method", lincoln_method);
  bodyFormData.set("macmillan_education", macmillan_education);
  bodyFormData.set("mcgraw_hill", mcgraw_hill);
  bodyFormData.set("scholastic", scholastic);
  bodyFormData.set("combination_resources", combination_resources);

  console.log("userid", userid);
  console.log("courseid", courseid);
  console.log("couponcode", couponcode);
  console.log("dayid", dayid);
  console.log("payinclass_details", payinclass_details);
  console.log("order_address", order_address);
  console.log("pickupmethod", pickupmethod);
  console.log("location", location);
  console.log("contact_number", contact_number);
  console.log("word_problem", word_problem);
  console.log("logic_reasoning", logic_reasoning);
  console.log("reading_comprehennsion", reading_comprehennsion);
  console.log("grammer_vocabulary", grammer_vocabulary);
  console.log("lincoln_method", lincoln_method);
  console.log("macmillan_education", macmillan_education);
  console.log("mcgraw_hill", mcgraw_hill);
  console.log("scholastic", scholastic);
  console.log("combination_resources", combination_resources);

  return instance
    .post("api/v1/class/checkout", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data == "") {
        return res;
        // dispatch({
        // 	type: _checkoutCashOnDevliverySuccess,
        // 	payload: {
        // 		orderStatus: res.data.orderStatus,
        // 		response: "already" + Math.random()
        // 	}
        // });
      } else {
        if (res.data.status == "success" && res.data.orderStatus != 0) {
          // if success only
          return res;
          // dispatch({
          // 	type: _checkoutCashOnDevliverySuccess,
          // 	payload: {
          // 		orderStatus: res.data.orderStatus,
          // 		response: "success" + Math.random()
          // 	}
          // });
        } else {
          return res;
          // dispatch({
          // 	type: _checkoutCashOnDevliverySuccess,
          // 	payload: {
          // 		orderStatus: res.data.orderStatus,
          // 		response: "error" + Math.random()
          // 	}
          // })
        }
      }
    })
    .catch((error) => {
      return error;
      // dispatch({
      // 	type: _checkoutCashOnDevliverySuccess,
      // 	payload: {
      // 		orderStatus: "",
      // 		response: "error" + Math.random()
      // 	}
      // });
    });
};

export const getDemoData = (user_id, clientId, page) => {
  return instance
    .get(`/api/v1/lm/user/feeds?student_id=${user_id}&client_id=${clientId}&page=${page}`, {
      headers: {
        "Content-Type": "application/JSON",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only

        return res;
      } else {
        if (res.data.status == "error") {
          return res;
        } else {
        }
      }
    })
    .catch((error) => {});
};

export const getChaptersData = (prog_id, student_id) => {
  debugger;
  var bodyFormData = new FormData();

  bodyFormData.set("prog_id", prog_id);
  bodyFormData.set("student_id", student_id);

  return instance
    .post("api/assignedprogramchapters", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      debugger;
      if (res.data.status == "success") {
        return res;
      } else {
        if (res.data.status == "success" && res.data.orderStatus != 0) {
          // if success only
          return res;
        } else {
          return res;
        }
      }
    })
    .catch((error) => {
      return error;
    });
};

export const getTopicsData = (prog_id, student_id, assess_id) => {
  var bodyFormData = new FormData();

  bodyFormData.set("prog_id", prog_id);
  bodyFormData.set("student_id", student_id);
  bodyFormData.set("assess_id", assess_id);

  return instance
    .post("api/assignedchaptertopics", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      debugger;
      if (res.data.status == "success") {
        return res;
      } else {
        if (res.data.status == "success" && res.data.orderStatus != 0) {
          // if success only
          return res;
        } else {
          return res;
        }
      }
    })
    .catch((error) => {
      return error;
    });
};

export const getSpecificFeed = (user_id, clientId, feedId) => {
  return instance
    .get(
      `api/v1/lm/user/specificfeed?student_id=${user_id}&client_id=${clientId}&feed_id=${feedId}`,
      {
        headers: {
          "Content-Type": "application/JSON",
        },
      }
    )
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only

        return res;
      } else {
        if (res.data.status == "error") {
          return res;
        } else {
        }
      }
    })
    .catch((error) => {});
};

//End Checkout Functions

export const getTesstParameter = (testId, userId) => {
  var bodyFormData = new FormData();

  bodyFormData.set("test_id", testId);
  bodyFormData.set("user_id", userId);

  return instance
    .post("api/v1/getteststatus", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getReferralPrice = (studentId) => {
  var bodyFormData = new FormData();

  bodyFormData.set("student_id", studentId);

  return instance
    .post("/api/v1/getappsettings", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.data.status != "undefined" && res.data.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
export const getSiblings = (column, val) => {
  var bodyFormData = new FormData();

  bodyFormData.set("column", column);
  bodyFormData.set("val", val);

  return instance
    .post("/api/v1/validate/user/column", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.status == 200) {
        if (typeof res.status != "undefined" && res.status == "success") {
          return res;
          // if success only
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: res.data.result,
          // });
        } else {
          return res;
          // dispatch({
          //   type: _studentDataResponse,
          //   payload: "error_" + Math.random(),
          // });
        }
      } else {
        return res;
        // dispatch({
        //   type: _studentDataResponse,
        //   payload: "error",
        // });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

//Evaluation Feed Actions

//End Evaluation Action

//upload the image upload by user to AWS storage
// export const removeFromCloudStorage = (imageData) => async (dispatch) => {

//     var header = {
//         headers: {
//             'Content-Type': 'application/json',
//             'appKey': 'lm-app'
//         }
//     };

// 	instance.post('/api/delimage', {'image' : imageData}, header)
// 		.then((res) => {

// 			console.log('here i have remove image from uploadToCloudStorage', res);

// 		})
// 		.catch((error) => {
// 			console.log(error);
// 		});

// }

// //get all programs assigned to specific student
// export const getAllRelatedChapters = (prog_id, student_id) => async (dispatch) => {

//     //console.log('here i am in storage upload func:',imageData);

//     var header = {
//         headers: {
//             'Content-Type': 'application/json',
//             'appKey': 'lm-app'
//         }
//     };

//     if (global.isOnline == 1) {

//         instance.post('/api/assignedprogramchapters',
//             {
//                 'prog_id' : prog_id,
//                 'student_id' : student_id
//             }, header)
//             .then((res) => {
//                 // console.log('here i get all related chapters/assessments: ', res);
//                 if (res.status == 200) {
//                     // if (typeof res.data.status != 'undefined' && res.data.status == 'success') { // if success only
//                     //     dispatch({
//                     //         type: relatedChapters,
//                     //         payload: res.data
//                     //     });
//                     // } else {
//                     //     dispatch({
//                     //         type: relatedChapters,
//                     //         payload: res.data
//                     //     })
//                     // }
//                 } else {
//                     global.showToastMessage('Some thing went wrong! Error code:' + res.status);
//                 }

//             })
//             .catch((error) => {
//                 console.log(error);
//                 if (typeof error.status === 'undefined')
//                     global.showToastMessage('Network error!');
//                 else
//                     global.showToastMessage('Some thing went wrong!');
//             });
//     } else {
//         global.showToastMessage('Please connect with an active internet(:');
//     }

// }

// //get all programs assigned to specific student
// export const getAllRelatedTopics = (prog_id, student_id, assess_id) => async (dispatch) => {

//     //console.log('here i am in storage upload func:',imageData);

//     var header = {
//         headers: {
//             'Content-Type': 'application/json',
//             'appKey': 'lm-app'
//         }
//     };

//     if (global.isOnline == 1) {

//         instance.post('/api/assignedchaptertopics',
//             {
//                 'prog_id' : prog_id,
//                 'student_id' : student_id,
//                 'assess_id' : assess_id
//             }, header)
//             .then((res) => {
//                 // console.log('here i get all related chapters/assessments: ', res);
//                 if (res.status == 200) {
//                     // if (typeof res.data.status != 'undefined' && res.data.status == 'success') { // if success only
//                     //     dispatch({
//                     //         type: relatedTopics,
//                     //         payload: res.data
//                     //     });
//                     // } else {
//                     //     dispatch({
//                     //         type: relatedTopics,
//                     //         payload: res.data
//                     //     })
//                     // }
//                 } else {
//                     global.showToastMessage('Some thing went wrong! Error code:' + res.status);
//                 }

//             })
//             .catch((error) => {
//                 console.log(error);
//                 if (typeof error.status === 'undefined')
//                     global.showToastMessage('Network error!');
//                 else
//                     global.showToastMessage('Some thing went wrong!');
//             });
//     } else {
//         global.showToastMessage('Please connect with an active internet(:');
//     }

// }
